<template>
  <Input
    :placeholder="placeholder"
    readonly
    :clearable="clearable"
    class="input-readonly"
    v-model="currentText"
  >
    <Button slot="append" size="small" v-if="sendTypeCheck" :disabled="disabled" @click="handleMu">
      <i class="fa fa-search"></i>
    </Button>
    <Button slot="append" size="small" v-else :disabled="disabled" @click="searchClick">
      <i class="fa fa-search"></i>
    </Button>



  </Input>
</template>
<script>
export default {
  name: "searchInput",
  props: {
    placeholder: {
      type: String,
      default: ""
    },
    value: {},
    text: {},
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    sendTypeCheck:{
        type:Boolean,
        default:false
    }
  },
  data() {
    return {
      currentValue: this.value,
      currentText: this.text
    };
  },
  watch: {
    value(n, o) {
      if (n == null) {
        this.currentText = "";
      }
    },
    currentValue(n, o) {
      this.$emit("update:text", this.currentText);
      this.$emit("input", n);
    },
    text(n, o) {
      this.$emit("update:text", n);
      this.currentText = this.text;
    },
    currentText(n, o) {
      if (n == "") {
        this.$emit("input", null);
      } else {
        if (this.value == null) {
          this.$emit("input", this.currentValue);
          this.$emit("update:text", this.currentText);
        } else {
          this.currentValue = this.value;
          this.$emit("input", this.currentValue);
          this.$emit("update:text", this.currentText);
        }
      }
    }
  },
  methods: {
    searchClick() {
      this.$emit("searchClick");
    }
  }
};
</script>




// WEBPACK FOOTER //
// SearchInput.vue?c84c9938